import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";
import ReactFlow, { Controls, Background, MarkerType } from "reactflow";
import "reactflow/dist/style.css";
import BgTitle from "components/title/BgTitle";

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;
const ScrollableContainer = styled.div`
  ${tw`relative`}
  width: 100%;
  height: 550px;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 600px;
  }
`;

const OrganizationChart = () => {
  const { t } = useTranslation();

  const orgNodes = [
    {
      id: "1",
      data: {
        label: t("about_us.organization_chart.nodes.board_of_directors"),
      },
      position: { x: 0, y: 100 },
    },
    {
      id: "2",
      data: { label: t("about_us.organization_chart.nodes.ceo") },
      position: { x: 200, y: 200 },
    },
    {
      id: "3",
      data: { label: t("about_us.organization_chart.nodes.executive_meeting") },
      position: { x: 200, y: 300 },
    },
    {
      id: "4",
      data: {
        label: t("about_us.organization_chart.nodes.management_department"),
      },
      position: { x: 200, y: 400 },
    },
    {
      id: "5",
      data: {
        label: t(
          "about_us.organization_chart.nodes.general_affairs_department"
        ),
      },
      position: { x: 600, y: 250 },
    },
    {
      id: "6",
      data: {
        label: t("about_us.organization_chart.nodes.general_affairs_section"),
      },
      position: { x: 600, y: 350 },
    },
    {
      id: "7",
      data: { label: t("about_us.organization_chart.nodes.business_section") },
      position: { x: 600, y: 450 },
    },
    {
      id: "8",
      data: {
        label: t("about_us.organization_chart.nodes.accounting_section"),
      },
      position: { x: 800, y: 200 },
    },
    {
      id: "9",
      data: {
        label: t("about_us.organization_chart.nodes.business_headquarters"),
      },
      position: { x: 1000, y: 50 },
    },
    {
      id: "10",
      data: {
        label: t("about_us.organization_chart.nodes.software_department"),
      },
      position: { x: 1000, y: 150 },
    },
    {
      id: "11",
      data: {
        label: t(
          "about_us.organization_chart.nodes.software_services_department"
        ),
      },
      position: { x: 1000, y: 250 },
    },
    {
      id: "12",
      data: { label: t("about_us.organization_chart.nodes.system_department") },
      position: { x: 1000, y: 350 },
    },
    {
      id: "13",
      data: {
        label: t("about_us.organization_chart.nodes.new_business_department"),
      },
      position: { x: 1000, y: 450 },
    },
    {
      id: "14",
      data: {
        label: t("about_us.organization_chart.nodes.partner_department"),
      },
      position: { x: 1200, y: 150 },
    },
    {
      id: "15",
      data: {
        label: t(
          "about_us.organization_chart.nodes.related_business_department"
        ),
      },
      position: { x: 1400, y: 50 },
    },
    {
      id: "16",
      data: { label: t("about_us.organization_chart.nodes.dalian_group") },
      position: { x: 1400, y: 150 },
    },
    {
      id: "17",
      data: { label: t("about_us.organization_chart.nodes.unix_holdings") },
      position: { x: 1400, y: 250 },
    },
    {
      id: "18",
      data: {
        label: t("about_us.organization_chart.nodes.knowledge_engineering"),
      },
      position: { x: 1400, y: 350 },
    },
    {
      id: "19",
      data: { label: t("about_us.organization_chart.nodes.gram") },
      position: { x: 1600, y: 150 },
    },
    {
      id: "20",
      data: {
        label: t("about_us.organization_chart.nodes.intelligent_systems"),
      },
      position: { x: 1600, y: 250 },
    },
    {
      id: "21",
      data: { label: t("about_us.organization_chart.nodes.nippon_asi") },
      position: { x: 1600, y: 350 },
    },
  ];

  const orgEdges = [
    { id: "e1-2", source: "1", target: "2", style: { stroke: "#1976d2" } },
    { id: "e2-3", source: "2", target: "3", style: { stroke: "#1976d2" } },
    { id: "e3-4", source: "3", target: "4", style: { stroke: "#42a5f5" } },
    { id: "e3-5", source: "3", target: "5", style: { stroke: "#42a5f5" } },
    { id: "e5-6", source: "5", target: "6", style: { stroke: "#42a5f5" } },
    { id: "e5-7", source: "5", target: "7", style: { stroke: "#42a5f5" } },
    { id: "e5-8", source: "5", target: "8", style: { stroke: "#ef5350" } },
    { id: "e2-9", source: "2", target: "9", style: { stroke: "#ef5350" } },
    { id: "e9-10", source: "9", target: "10", style: { stroke: "#ef5350" } },
    { id: "e9-11", source: "9", target: "11", style: { stroke: "#ef5350" } },
    { id: "e9-12", source: "9", target: "12", style: { stroke: "#ef5350" } },
    { id: "e9-13", source: "9", target: "13", style: { stroke: "#8e24aa" } },
    { id: "e9-14", source: "9", target: "14", style: { stroke: "#5c6bc0" } },
    { id: "e9-15", source: "9", target: "15", style: { stroke: "#5c6bc0" } },
    { id: "e14-16", source: "14", target: "16", style: { stroke: "#5c6bc0" } },
    { id: "e15-17", source: "15", target: "17", style: { stroke: "#5c6bc0" } },
    { id: "e15-18", source: "15", target: "18", style: { stroke: "#42a5f5" } },
    { id: "e15-19", source: "15", target: "19", style: { stroke: "#42a5f5" } },
    { id: "e15-20", source: "15", target: "20", style: { stroke: "#42a5f5" } },
    { id: "e15-21", source: "15", target: "21", style: { stroke: "#42a5f5" } },
  ];

  return (
    <BgWrapper>
      <BgTitle text={t("about_us.organization_chart.title")} isCenter={true} />
      <ScrollableContainer>
        <ReactFlow
          nodes={orgNodes}
          edges={orgEdges}
          nodesDraggable={true}
          fitView
          defaultNodeOptions={{ draggable: true }}
          defaultEdgeOptions={{
            animated: true,
            markerEnd: { type: MarkerType.Arrow },
          }}
          zoomOnScroll={false} // Disable zooming with scroll
          zoomOnPinch={false} // Disable zooming with pinch gestures
          panOnScroll={false} // Disable panning with scroll
          panOnDrag={true} // Allow panning only via drag
          preventScrolling={false} // Allow page scroll when mouse is over the chart
        >
          <Controls />
          <Background color="#eee" gap={16} />
        </ReactFlow>
      </ScrollableContainer>
    </BgWrapper>
  );
};

export default OrganizationChart;
